import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import RegisterNow from "./components/common/RegisterNow/RegisterNow";
import ForgetPassword from "./components/common/ForgetPassword/ForgetPassword";
import ForgetPasswordVerification from "./components/common/ForgetPasswordVerification/ForgetPasswordVerification";
import Registration from "./components/common/Registration/Registration";
import StepperData from "./components/ip/StepperData";
import DdStepperData from "./components/dd/DdStepperData";
import Dashboard from "./components/common/Dashboard/Dashboard";
import OttStepperData from "./components/ott/OttStepperData";
import Checksession from "./components/Checksession";
import Checkpayment from "./components/Checkpayment";
import Logout from "./components/common/Logout";
import IpView from "./components/ip/IpView/IpView";

import CmotStepperData from "./components/cmot/CmotStepperData";
import OttView from "./components/ott/OttView/OttView";
import CmotView from "./components/cmot/CmotVew/CmotView";
import Test from "./components/common/Testt/Test";
import CheckpaymentOtt from "./components/CheckpaymentOtt";
import VerifyEmail from "./components/common/Registration/VerifyEmail";
import NotFound from "./components/common/NotFound/NotFound";
import Checklogout from "./components/Checklogout";
import { isTimeUp } from "../src/components/Helper";
import DdView from "./components/dd/DdView/DdView";
import CheckDDpayment from "./components/CheckDDpayment";
import CinemaStepperData from "./components/Cinema/CinemaStepperData";
import CinemaiView from "./components/Cinema/CinemaiView";
const App = () => {
  const targetDateString = process.env.REACT_APP_TARGET_DATE; // Date from the .env file
  const timeUp = isTimeUp(targetDateString); // Check if the time is up
  const ipform_expiry_date = process.env.REACT_APP_IP_FORM_EXPIRY_DATE;
  const iptimeUp = isTimeUp(ipform_expiry_date);
  const DDform_expiry_date = process.env.REACT_APP_DD_FORM_EXPIRY_DATE;
  const ddtimeUp = isTimeUp(DDform_expiry_date);

  return (
    <div className="reactglobal">
      <BrowserRouter basename={process.env.REACT_APP_BASE_PREFIX}>
        <Routes>
          <Route path="/testt" element={<Test />} />
          <Route
            path="/:param"
            element={
              <Checklogout>
                <RegisterNow />
              </Checklogout>
            }
          />
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/"
            element={
              <Checklogout>
                <RegisterNow />
              </Checklogout>
            }
          />
          <Route
            path="/forget-password"
            element={
              <Checklogout>
                <ForgetPassword />
              </Checklogout>
            }
          />
          <Route
            path="/password-verify"
            element={
              <Checklogout>
                <ForgetPasswordVerification />
              </Checklogout>
            }
          />
          <Route
            path="/registration"
            element={
              <Checklogout>
                <Registration />
              </Checklogout>
            }
          />
          <Route
            path="/dashboard"
            element={
              <Checksession>
                <Dashboard />
              </Checksession>
            }
          />
          <Route
            path="/dashboard/:tabName"
            element={
              <Checksession>
                <Dashboard />
              </Checksession>
            }
          />
          {!iptimeUp ? (
            <>
              <Route
                path="/ip"
                element={
                  <Checksession>
                    <StepperData />
                  </Checksession>
                }
              />
              <Route
                path="/ip/:id"
                element={
                  <Checksession>
                    <StepperData />
                  </Checksession>
                }
              />
              <Route
                path="/ip/:id/:ip_step"
                element={
                  <Checksession>
                    <StepperData />
                  </Checksession>
                }
              />
            </>
          ) : (
            <Route path="*" element={<Navigate to="/dashboard" />} />
          )}

          <Route
            path="/ip/view/:id"
            element={
              <Checksession>
                <Checkpayment>
                  <IpView />
                </Checkpayment>
              </Checksession>
            }
          />

          {/* OTT Routes */}
          {!timeUp ? (
            <>
              <Route
                path="/ott"
                element={
                  <Checksession>
                    <OttStepperData />
                  </Checksession>
                }
              />
              <Route
                path="/ott/:id"
                element={
                  <Checksession>
                    <OttStepperData />
                  </Checksession>
                }
              />
              <Route
                path="/ott/:id/:ip_step"
                element={
                  <Checksession>
                    <OttStepperData />
                  </Checksession>
                }
              />
            </>
          ) : (
            <Route path="*" element={<Navigate to="/dashboard/ott" />} />
          )}

          <Route
            path="/ott/view/:id"
            element={
              <Checksession>
                <CheckpaymentOtt>
                  <OttView />
                </CheckpaymentOtt>
              </Checksession>
            }
          />

          {/* CMOT Routes */}
          <Route
            path="/cmot"
            element={
              <Checksession>
                <CmotStepperData />
              </Checksession>
            }
          />
          <Route
            path="/cmot/:id"
            element={
              <Checksession>
                <CmotStepperData />
              </Checksession>
            }
          />
          <Route
            path="/cmot/:id/:ip_step"
            element={
              <Checksession>
                <CmotStepperData />
              </Checksession>
            }
          />

          <Route
            path="/cmot/view/:id"
            element={
              <Checksession>
                <CmotView />
              </Checksession>
            }
          />

          {/* cinema AI  */}

          <Route
            path="/cinemai-hackathon"
            element={
              <Checksession>
                <CinemaStepperData />
              </Checksession>
            }
          />
          <Route
            path="/cinemai-hackathon/:id"
            element={
              <Checksession>
                <CinemaStepperData />
              </Checksession>
            }
          />
          <Route
            path="/cinemai-hackathon/:id/:ip_step"
            element={
              <Checksession>
                <CmotStepperData />
              </Checksession>
            }
          />

          <Route
            path="/cinemai-hackathon/view/:id"
            element={
              <Checksession>
                <CinemaiView />
              </Checksession>
            }
          />

          <Route path="/verify/:token" element={<VerifyEmail />} />
          <Route path="/not-found" element={<NotFound />} />

          {/* Director Debut (dd) */}
          {!ddtimeUp ? (
            <>
              <Route
                path="/dd"
                element={
                  <Checksession>
                    <DdStepperData />
                  </Checksession>
                }
              />
              <Route
                path="/dd/:id"
                element={
                  <Checksession>
                    <DdStepperData />
                  </Checksession>
                }
              />
              <Route
                path="/dd/:id/:ip_step"
                element={
                  <Checksession>
                    <DdStepperData />
                  </Checksession>
                }
              />
            </>
          ) : (
            <Route path="*" element={<Navigate to="/dashboard/dd" />} />
          )}

          <Route
            path="/dd/view/:id"
            element={
              <Checksession>
                <CheckDDpayment>
                  <DdView />
                </CheckDDpayment>
              </Checksession>
            }
          />

          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};
export default App;
